export default __webpack_public_path__ + "rma.c6e7af8a.png";